const language = {
    'pt': 
        {
            calendar_language:  'pt-PT',
            calendar:           'Calendário',
            calendar_allday:    'Todo o dia',
            calendar_busy:      'Ocupado',
            calendar_daynames:  ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            calendar_free:      'Livre',
            calendar_title_placeholder:     'Assunto',
            calendar_location_placeholder:  'Localização',
            calendar_start_placeholder:     'Data de inicio',
            calendar_end_placeholder:       'Data de fim',
            calendar_save:      'Salvar',
            calendar_update:    'Atualizar',
            calendar_edit:      'Editar',
            calendar_delete:    'Apagar',
            calendar_today:     'Hoje',
            calendar_viewall:   'Ver tudo',
            calendar_month:     'Mês',
            calendar_week:      'Semana',
            calendar_day:       'Dia',
            cancel:             'Cancelar',
            category:           'Categoria',
            category_new:       'Nova categoria',
            category_edit:      'Editar categoria',
            category_list:      'Lista de categorias',
            close:              'Fechar',
            color:              'Cor',
            color_placeholder:  'Introduza a cor',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            principal:          'Principal',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            save:               'Salvar',                  
        },
    'en':
        {
            calendar_language:  'en-GB',
            calendar:           'Calendar',
            calendar_allday:    'All day',
            calendar_busy:      'Busy',
            calendar_daynames:  ['Sun', 'Mon', 'Thu', 'Wed', 'Thr', 'Fri', 'Sat'],
            calendar_free:      'Free',
            calendar_title_placeholder:     'Subject',
            calendar_location_placeholder:  'Location',
            calendar_start_placeholder:     'Start date',
            calendar_end_placeholder:       'End date',
            calendar_save:      'Save',
            calendar_update:    'Update',
            calendar_edit:      'Edit',
            calendar_delete:    'Delete',
            calendar_today:     'Today',
            calendar_viewall:   'View all',
            calendar_month:     'Month',
            calendar_week:      'Week',
            calendar_day:       'Day',
            cancel:             'Cancel',
            category:           'Category',
            category_new:       'Ney category',
            category_edit:      'Editar category',
            category_list:      'List of categories',
            close:              'Close',
            color:              'Color',
            color_placeholder:  'Insert the color',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            id:                 'ID',
            name:               'Name',
            name_placeholder:   'Insert the name',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            principal:          'Principal',
            remove:             'Remove',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_state:        'State',
            table_actions:      'Actions',
            table_empty:        'no results',
            save:               'Save',
        }
}

module.exports = {
    language
};